import { ImagePositionOnPage } from '../../shared/enums/image-position-on-page.enum';
import { QuestionInstance } from '../../shared/enums/question-instance.enum';
import { Hint } from '../hint.model';
import { Image } from './image.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export abstract class Question {
  public id!: string;

  public value!: string;

  public hints!: Hint[];

  public imageTemplate?: ImagePositionOnPage;

  public type!: QuestionInstance;

  public biebVideoId?: string;

  public images!: Image[];

  protected static mapBaseProperties(question: Question, dto: any): void {
    question.id = dto.id;
    question.value = dto.value;
    question.hints =
      dto.hints?.map((hintDto: any) => Hint.fromDto(hintDto)) ?? [];
    question.imageTemplate = dto.imageTemplate;
    question.type = dto.type;
    question.biebVideoId = dto.biebVideoId;
    question.images = Question.mapImages(dto.questionHasImages);
  }

  private static mapImages(value: any): Image[] {
    if (!value) {
      return [];
    }
    if (Array.isArray(value)) {
      const images: Image[] = value.map(
        (item: any) =>
          new Image(item.image.id, item.image.imageUrl, item.orderPosition),
      );
      images.sort((a: Image, b: Image) => a.position - b.position);
      return images;
    }
    return value;
  }
}
